<template>
  <message-template :direction="direction" :time="time" :channel="channel">
    <div class="log-video-block">
      <div class="video">
        <video class="fullwidth" ref="video_ref" controls v-html="videoSrc"></video>
      </div>
    </div>
  </message-template>
</template>
<script>
import MessageTemplate from './MessageTemplate.vue';

export default {
  name: 'buttonTemplate',
  components: {
    'message-template': MessageTemplate,
  },
  props: {
    data: {
      type: Object,
    },
    direction: {
      type: String,
      default: '',
    },
    videoUrlField: {
      type: String,
      default: 'url',
    },
    time: {
      type: Number,
      default: 0,
    },
    channel: {
      type: String,
      default: '',
    },
    uid: {
      type: String,
    },
  },
  computed: {
    videoSrc() {
      if (this.data && this.data[this.videoUrlField]) {
        return `<source type="video/mp4" src="${this.data[this.videoUrlField]}">`;
      } if (this.data
        && this.data.answers
        && this.data.answers[0]
        && this.data.answers[0][this.videoUrlField]) {
        return `<source type="video/mp4" src="${this.data.answers[0][this.videoUrlField]}">`;
      }
      return '';
    },
  },
};
</script>
<style lang="scss" scoped>
.log-video-block {
  min-height: 200px;
  overflow: hidden;
  background-color: #efefef;
  border-radius: 10px 10px 10px 10px;
  .video {
    width: 100%;
  }
  video.fullwidth {
    min-width: 320px;
    width: 100% !important;
  }
}
</style>
